// Feather Observer Service
// Automatically initializes Feather icons when new content is added to the DOM

import feather from 'feather-icons'

let mutationObserver = null

export const initializeFeatherObserver = () => {
  feather.replace()

  mutationObserver = new MutationObserver(() => {
    requestAnimationFrame(() => {
      feather.replace()
    })
  })

  mutationObserver.observe(document.body, {
    childList: true,
    subtree: true
  })
}

document.addEventListener('DOMContentLoaded', initializeFeatherObserver)
document.addEventListener('turbo:load', initializeFeatherObserver)
document.addEventListener('turbo:render', initializeFeatherObserver)
document.addEventListener('turbo:frame-load', initializeFeatherObserver)